export default __webpack_public_path__ + "static/media/Discount.0837f444.png";